import React from 'react';
import { matchPath, withRouter } from 'react-router-dom';
import { MenuLink } from '@econ/ui-elements';
import Authorize from './Authorize';
import Text from './l10n/TextByRoute';

function AuthorizedMenuLink({ children, history, href, location, onClick, route, ignoreTranslations }: any) {
    const isExternal = href.startsWith('http');
    const isActive = matchPath(href, { path: location.pathname, exact: true });

    return (
        <Authorize route={route || href}>
            <MenuLink
                active={isActive}
                href={href}
                onClick={
                    isExternal
                        ? null
                        : () => {
                              history.push(href);

                              if (onClick) {
                                  onClick();
                              }
                          }
                }
                target={isExternal ? '_blank' : null}>
                {ignoreTranslations ? <span>{children}</span> : <Text route={href}>{children}</Text>}
            </MenuLink>
        </Authorize>
    );
}

export default withRouter(AuthorizedMenuLink);
